// Whiskcam Gallery Enhancements
// - Mobile dots/pills navigation synced with slider
// - Pauses asset videos when navigating away from their slide
(function () {
  'use strict';

  function initGallery(gallery) {
    var viewerComponent = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewerComponent) return;

    var slider = viewerComponent.querySelector('.product__media-list');
    if (!slider) return;

    var slides = Array.from(slider.querySelectorAll(':scope > .slider__slide'));
    if (slides.length < 2) return;

    var dotsContainer = gallery.querySelector('.wk-gallery-dots');

    if (dotsContainer) {
      buildDots(dotsContainer, slides, slider, viewerComponent);
    }

    // Pause asset videos when slide changes (Dawn also calls pauseAllMedia, but belt-and-suspenders)
    viewerComponent.addEventListener('slideChanged', function (event) {
      var currentEl = event.detail && event.detail.currentElement;

      if (dotsContainer && currentEl) {
        var idx = slides.indexOf(currentEl);
        if (idx !== -1) updateDots(dotsContainer, idx);
      }

      slider.querySelectorAll('.wk-asset-video').forEach(function (video) {
        if (!currentEl || !currentEl.contains(video)) {
          video.pause();
        }
      });
    });
  }

  function buildDots(container, slides, slider, viewerComponent) {
    container.innerHTML = '';

    slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wk-gallery-dot';
      dot.setAttribute('aria-label', 'View image ' + (i + 1) + ' of ' + slides.length);
      dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');

      dot.addEventListener('click', function () {
        // Delegate to the MediaGallery web component when possible
        var mgEl = container.closest('media-gallery');
        if (mgEl && typeof mgEl.setActiveMedia === 'function' && slide.dataset.mediaId) {
          mgEl.setActiveMedia(slide.dataset.mediaId, false);
        } else {
          slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        updateDots(container, i);
      });

      container.appendChild(dot);
    });

    // Scroll-based sync (covers swipe + thumbnail clicks that don't fire slideChanged)
    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var scrollLeft = slider.scrollLeft;
        var closestIndex = 0;
        var minDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closestIndex = i;
          }
        });
        updateDots(container, closestIndex);
      }, 80);
    });
  }

  function updateDots(container, activeIndex) {
    container.querySelectorAll('.wk-gallery-dot').forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
